import React, { useEffect, useState } from "react";
import styles from "../Dashoard.module.css";
import Button from "@mui/material/Button";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import { StripeWordSIcon } from "../../../assets/icons/StripeWordSIcon";
import { StripeTextIcon } from "../../../assets/icons/StripeTextIcon";
import Grid from "@mui/material/Grid";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SideDrawer from "../../SideDrawerNew/SideDrawer";
import SelectField from "../../SelectField/SelectField";
import { apiRequest } from "../../../utils/axiosInstance";
import { toast } from "react-toastify";
import { getUserData } from "../../../hooks/HelperFunctions";

const GetStarted = (props) => {
  const {
    isStripeConnectedForOrg,
    isStripeCompleted,
    createOrGetAccountLinkHandler,
    isSetupTeachingPageCompleted = false,
  } = props;

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const initialSelectOption = [
    { label: "Select Country", value: "0" },
    { label: "Australia", value: "AU" },
    { label: "Austria", value: "AT" },
    { label: "Belgium", value: "BE" },
    { label: "Bulgaria", value: "BG" },
    { label: "Canada", value: "CA" },
    { label: "Croatia", value: "HR" },
    { label: "Cyprus", value: "CY" },
    { label: "Czech Republic", value: "CZ" },
    { label: "Denmark", value: "DK" },
    { label: "Estonia", value: "EE" },
    { label: "Finland", value: "FI" },
    { label: "France", value: "FR" },
    { label: "Germany", value: "DE" },
    { label: "Gibraltar", value: "GI" },
    { label: "Greece", value: "GR" },
    { label: "Hong Kong SAR China", value: "HK" },
    { label: "Hungary", value: "HU" },
    { label: "Ireland", value: "IE" },
    { label: "Italy", value: "IT" },
    { label: "Japan", value: "JP" },
    { label: "Latvia", value: "LV" },
    { label: "Liechtenstein", value: "LI" },
    { label: "Lithuania", value: "LT" },
    { label: "Luxembourg", value: "LU" },
    { label: "Malta", value: "MT" },
    { label: "Mexico", value: "MX" },
    { label: "Netherlands", value: "NL" },
    { label: "New Zealand", value: "NZ" },
    { label: "Norway", value: "NO" },
    { label: "Poland", value: "PL" },
    { label: "Portugal", value: "PT" },
    { label: "Romania", value: "RO" },
    { label: "Singapore", value: "SG" },
    { label: "Slovakia", value: "SK" },
    { label: "Slovenia", value: "SI" },
    { label: "Spain", value: "ES" },
    { label: "Sweden", value: "SE" },
    { label: "Switzerland", value: "CH" },
    { label: "Thailand", value: "TH" },
    { label: "United Arab Emirates", value: "AE" },
    { label: "United Kingdom", value: "GB" },
    { label: "United States", value: "US" },
  ];
  const [cardData, setCardData] = useState([]);
  const [showCardSection, setShowCardSection] = useState(false);
  const [openConnectStripeSideDrawer, setOpenConnectStripeSideDrawer] =
    useState(false);
  const [countriesOptions, setCountriesOptions] = useState(initialSelectOption);
  const [selectedCountry, setSelectedCountry] = useState("0");

  useEffect(() => {
    if (selectedCountry != 0) {
      localStorage.setItem(
        "selected_country_for_stripe_connect",
        selectedCountry,
      );
    }
  }, [selectedCountry]);
  // useEffect(() => {
  //   getStripeAllowedCountries()
  // },[])
  useEffect(() => {
    if (isStripeConnectedForOrg !== null) {
      getVerifyStripeHandler();
    }
  }, [isStripeConnectedForOrg]);

  const createCountriesOptions = (data) => {
    let countriesOptions = [initialSelectOption];

    if (data?.length) {
      countriesOptions = countriesOptions.concat(
        data.map((single) => ({
          label: single.name,
          value: single.short_name,
        })),
      );

      countriesOptions = countriesOptions.concat({
        label: "United States",
        value: "US",
      });
    }

    console.log(countriesOptions);
    return countriesOptions;
  };
  // const getStripeAllowedCountries = async () => {
  //   try {
  //     const data = await apiRequest(
  //       "/stripe-supported-countries",
  //       "GET",
  //       null
  //     );

  //     if (!data?.error) {
  //       setCountriesOptions(createCountriesOptions(data?.data))
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  const openStripePrimaryValueDrawerHandler = () => {
    setOpenConnectStripeSideDrawer(true);
  };

  const getStartedHandler = async () => {
    const userInfo = getUserData();

    if (userInfo && Object.keys(userInfo).length > 0) {
      // show loading spinner/backdrop

      try {
        let currentOrtId = localStorage.getItem("orgId");
        let teachingAccounts = localStorage.getItem("teachingAccounts")
          ? JSON.parse(localStorage.getItem("teachingAccounts"))
          : [];

        let found = teachingAccounts.find(
          (single) => single.orgId == currentOrtId,
        );
        let jwtToken = localStorage.getItem("jwtToken");

        const postData = {
          orgId: currentOrtId,
          jwt_token: jwtToken,
          slug: found?.subDomain,
        };
        const response = await apiRequest(
          "/generateLoginCode",
          "POST",
          postData,
        );

        const { code } = response;

        if (code) {
          // Construct Become a teacher URL with code
          const appBUrl = `${process.env.NEXT_PUBLIC_TEACHER_SETTINGS_URL}?code=${encodeURIComponent(code)}`;
          // console.log("🚀 ~ getStartedHandler ~ appBUrl:", appBUrl)
          // return false
          window.location.href = appBUrl;
        } else {
          console.error("No code returned from API");
        }
      } catch (error) {
        console.error("Error generating login code:", error);
      } finally {
      }
    } else {
      console.log("No user found");

      sessionStorage.setItem("from_become_a_teacher", true);

      setOpenSignUpModel(true);
    }
  };

  const getVerifyStripeHandler = async () => {
    let newCardData = [];

    if (!isStripeConnectedForOrg) {
      newCardData.push({
        key: "verify_stripe",
        statusIcon: isStripeConnectedForOrg ? (
          <CheckCircleIcon />
        ) : (
          <WarningIcon style={{ color: "#EF7531" }} />
        ),
        title: "To accept payments, please connect with Stripe",
        chipStatus: true,
        chip: "Required",
        StripeButtonStatus: !isStripeConnectedForOrg,
        buttonLabel: "Connect with",
        actionButtonClick: (e) => {
          openStripePrimaryValueDrawerHandler();
        },
      });
    }
    if (!isSetupTeachingPageCompleted) {
      newCardData.push({
        key: "verify_stripe",
        statusIcon: isSetupTeachingPageCompleted ? (
          <CheckCircleIcon />
        ) : (
          <WarningIcon style={{ color: "#EF7531" }} />
        ),
        title: "Set up your teaching page",
        chipStatus: true,
        chip: "Required",
        actionButtonStatus: true,
        buttonLabel: "Set up",
        actionButtonClick: (e) => {
          getStartedHandler();
        },
      });
    }
    if (newCardData?.length > 0) {
      setShowCardSection(true);
    }
    setCardData(newCardData);
  };

  const hideCard = (index) => {
    let newCardData = [...cardData];

    newCardData = newCardData?.filter((cardData, i) => index != i);

    setCardData(newCardData);
  };

  const hideCardSection = () => {
    setShowCardSection(false);
  };

  // const cardData = [
  //   {
  //     statusIcon: <CheckCircleIcon />,
  //     title: "To accept payments, please connect with Stripe",
  //     chipStatus: true,
  //     chip: "Required",
  //     StripeButtonStatus: true,
  //     buttonLabel: "Connect with",
  //     //actionButtonClick:{},
  //   },

  //   {
  //     statusIcon: <WarningIcon style={{ color: "#EF7531" }} />,
  //     title: "Verify your phone number",
  //     chipStatus: true,
  //     chip: "Required",
  //     actionButtonStatus: true,
  //     buttonLabel: "Browse courses",
  //     //actionButtonClick:{},
  //   },

  //   {
  //     statusIcon: <WarningIcon style={{ color: "#EF7531" }} />,
  //     title: "Verify your phone number",
  //     chipStatus: true,
  //     chip: "Recommended",
  //     actionButtonStatus: true,
  //     buttonLabel: "Add phone",
  //     //actionButtonClick:{},
  //   },
  // ]

  const handleContinue = () => {
    if (selectedCountry == "0") {
      toast.error("Please select a country");
      return false;
    }
    if (!isStripeConnectedForOrg) {
      createOrGetAccountLinkHandler();
    } else {
      console.log("no accesible function");
    }
  };

  const handleCloseModal = () => {
    setOpenConnectStripeSideDrawer(false);
    setSelectedCountry("0");
    localStorage.removeItem("selected_country_for_stripe_connect");
  };

  return (
    <>
      {showCardSection && cardData?.length > 0 && (
        <div className={styles.CardSection} style={{ marginTop: "21px" }}>
          <div className={styles.CardSectionTitle}>
            Quick ways to get started{" "}
            <Button
              className={styles.SeaAllButton}
              variant="text"
              onClick={(e) => hideCardSection()}
            >
              Hide
            </Button>
          </div>

          {cardData.map((item, i) => (
            <div className={styles.GetStartedCard}>
              <div className={styles.GetStartedCardLeft}>
                {item.statusIcon}
                <h2>{item.title}</h2>
                {item.chipStatus && (
                  <div className={styles.GetStartedGreyChip}>{item.chip}</div>
                )}
              </div>

              <div className={styles.GetStartedCardRight}>
                {item.actionButtonStatus && (
                  <Button
                    className={styles.GetStartedButton}
                    variant="text"
                    onClick={item.actionButtonClick}
                  >
                    {item.buttonLabel}
                  </Button>
                )}

                {item.StripeButtonStatus && (
                  <Button
                    className={styles.StripeButton}
                    variant="text"
                    onClick={item.actionButtonClick}
                  >
                    <StripeWordSIcon />{" "}
                    <div className={styles.StripeLine}></div>
                    {item.buttonLabel}{" "}
                    <div className={styles.StripeTextIcon}>
                      <StripeTextIcon />
                    </div>
                  </Button>
                )}
                {item.GetStartedButtonClose && (
                  <Button
                    className={styles.GetStartedButtonClose}
                    variant="text"
                    onClick={(e) => hideCard(i)}
                  >
                    <CloseIcon />
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      <SideDrawer
        drawerWidth="744px"
        padding="24px"
        title="Connect Stripe"
        ButtonLabel="Continue"
        cancelButtonLabel="Cancel"
        sideOpen="right"
        open={openConnectStripeSideDrawer}
        handleDrawerClose={handleCloseModal}
        clickSaveButton={() => handleContinue()}
        FooterWithoutTab={true}
        body={
          <div className="ResorceDrwContainer">
            <div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  <SelectField
                    label="Select Country"
                    validation={true}
                    options={countriesOptions}
                    selectedOption={selectedCountry}
                    defaultValue={selectedCountry}
                    handleChange={(e) => setSelectedCountry(e.target.value)}
                    // error={tempResourseError?.modId}
                    // FieldErrorLabel={tempResourseError?.modId}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
        }
      />
    </>
  );
};

export default GetStarted;
